import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, Tabs, Tab } from 'Core/components';
import PlantDetailsForm from './plant-details-form';
import CustomPropTypes from 'Core/prop-types';
import { AppModal } from '../components/app-modals';
import { showToast } from 'Core/redux/toast/slice';
import MaintenanceHistory from './maintenance-history';
import SafetyChecklist from './safety-checklist';
import CellHistory from './cell-history';
import SafetyChecklistHistory from './safety-checklist-history';
import EditPlant from './edit-plant';

const saveKeys = ['changed', 'id', 'isDeleted', 'userId'];
const editKeys = ['changed', 'isDeleted'];

const PlantAddEdit = ({ showModal, modalData, onCloseModal }) => {
  console.log('PlantAddEdit -> modalData:', modalData);
  const plantData = modalData;
  const [formData, setFormData] = useState(plantData || null);
  const [cellData, setCellData] = useState(null);
  const [safetyData, setSafetyData] = useState(null);
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  console.log('PlantAddEdit -> formData?.id:', formData?.id);
  console.log('PlantAddEdit -> formData?.plantId:', formData?.plantId);

  const dispatch = useDispatch();
  const isEditMode = Boolean(plantData?.id || plantData?.assetNumber);

  const onChangesPlantForm = data => {
    setFormData(data);
  };

  const onCellHistoryActionClick = (data, mode) => {
    setCellData({ data: data, mode: mode });
    setActiveTabIndex(1);
  };

  const onSafetyChecklistHistActionClick = (data, mode) => {
    setSafetyData({ mode: mode });
    setActiveTabIndex(3);
  };

  const handleTabChange = (newTabIndex) => {
    if (activeTabIndex === 1 && newTabIndex !== 1) {
      setCellData(null);
    }
    if (activeTabIndex === 3 && newTabIndex !== 3) {
      setSafetyData(null);
    }
    setActiveTabIndex(newTabIndex);
  };

  const handleClose = () => {
    onCloseModal();
  };

  const body = () => {
    return (
      <div className="row">
        {isEditMode && (
          <Tabs activeIndex={activeTabIndex} onTabChange={handleTabChange}>
            <Tab title="Edit Plant">
              <EditPlant
                data={formData}
                onChanges={onChangesPlantForm}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Plant Maintenance Details">
              <PlantDetailsForm
                data={formData}
                isEditMode={true}
                cellActionRecord={cellData}
                onChanges={onChangesPlantForm}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Maintenance Records History">
              <MaintenanceHistory
                data={formData}
                plantId={formData?.plantId || formData?.id}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Safety Checklist">
              <SafetyChecklist
                plantId={formData?.plantId || formData?.id}
                onCloseModal={handleClose}
                safetyActionRecord={safetyData}
              />
            </Tab>
            <Tab title="Cell History">
              <CellHistory
                assetNumber={formData.assetNumber}
                onActionClick={onCellHistoryActionClick}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Safety Checklist History">
              <SafetyChecklistHistory
                data={formData}
                onChanges={onChangesPlantForm}
                onCloseModal={handleClose}
                plantId={formData?.plantId || formData?.id}
                onActionClick={onSafetyChecklistHistActionClick}
              />
            </Tab>
          </Tabs>
        )}
        {!isEditMode && (
          <EditPlant
            data={formData}
            onChanges={onChangesPlantForm}
            onCloseModal={handleClose}
          />
        )}
      </div>
    );
  };

  const valid = () => {
    const ignoreKeys = isEditMode ? editKeys : saveKeys;
    if (
      !formData ||
      Object.keys(formData).some(key => {
        return !ignoreKeys.includes(key) && !formData[key];
      })
    ) {
      dispatch(
        showToast({
          message: 'Please fill all required fields',
          type: 'danger',
        }),
      );
      return false;
    }
    return true;
  };

  return (
    <Modal
      id="plant-modal"
      show={showModal}
      size="xl"
      title={isEditMode ? 'Plant Maintenance Summary' : 'Add Plant'}
      body={body}
      handleClose={handleClose}
    />
  );
};

PlantAddEdit.propTypes = {
  showModal: PropTypes.bool,
  modalData: PropTypes.shape(CustomPropTypes.Machines),
  onCloseModal: PropTypes.func,
};

export default AppModal(PlantAddEdit);
